import './SPEEDlink.scss';
import React, { Component } from 'react';

import Logger from '@KrashidBuilt/common/utils/logger';

import api from '../../../api';

import { Colors, Orientation } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import { FormContainer, FormSection } from '@fifth-gear-tech/common-components/dist/components';
import { Checkbox, Typography } from '@material-ui/core';

import { UserContext } from '../../../ctx';

const logger = new Logger(__filename);

/**
 * Parts Component
 * @augments {Component<Props, State>}
 */
class SPEEDlink extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            jwd: false,
        };
    }


    load = () => {
        this.setState({ loading: true }, async () => {
            try {
                const [{ jwd }] = await api.speed_link.getJWD();
                this.setState({ loading: false, jwd });
            } catch (err) {
                logger.error(err);
                this.setState({ loading: false });
            }
        });
    }

    componentDidMount() {
        const { loaded } = this.state;
        if (!loaded) {
            this.load();
        }
    }

    toggle = () => {
        const { jwd } = this.state;
        this.setState({ loading: true }, async () => {
            await api.speed_link.toggleJWD();
            this.setState({ jwd: !jwd, loading: false });
        });
    }

    render() {
        const { jwd } = this.state;

        return (
            <div className={'SPEEDlink'}>
                <FormContainer title={''}>
                    <FormSection label={'SPEEDlink'} subtext={'ERP link integrations'} colorTheme={Colors.Grey} orientation={Orientation.Mobile}>
                        <div style={{ marginLeft: '-0.7rem' }}>
                            <Typography variant='body1'>
                                <Checkbox size='large' color='black' checked={jwd} onChange={() => this.toggle()} />
                                Job Well Done
                            </Typography>
                        </div>
                    </FormSection>
                </FormContainer>
            </div>
        );
    }
}

SPEEDlink.contextType = UserContext;

export default SPEEDlink;
